type SourcesProps = {
    sources: string[];
};

export function SourcesBlock({ sources }: SourcesProps) {
    return (
        <div
            className="flex items-center justify-center bg-light-grey"
            style={{
                paddingLeft: 'env(safe-area-inset-left)',
                paddingRight: 'env(safe-area-inset-right)',
            }}
        >
            <div className="m-20 w-full max-w-[456px]">
                <p className="py-10 text-body-headline text-text-grey">
                    Kilder
                </p>

                {sources.map((source, index) => (
                    <p
                        key={index}
                        className="mb-20 mt-10 text-body [overflow-wrap:anywhere]"
                    >
                        {source}
                    </p>
                ))}
            </div>
        </div>
    );
}
